import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import {
  currentDateHourDb,
  formatDateDb,
  formatDateHourDb,
  formatTimeDb,
} from "../utils/tools";
import {
  customDateFormatType,
  formatDateForInput,
  formatNumber,
  formatPriceUS,
} from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.lockingManagement;
const queryKey = "paymentServiceFee";

async function fetchPaymentServiceFee(
  currentPage,
  search,
  lockingId,
  period,
  periodPayment,
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (lockingId) options.lockingId = lockingId;
    // if (period) options.period = period;
    if (periodPayment) options.periodPayment = periodPayment;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI(
      "get",
      `/totalCommission/paymentPeriod/paymentServiceFee?${queryParams}`,
    );
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries,
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?._id || "",
        code: item?.employeeObject?.code || "-",
        fullName: item?.employeeObject?.fullName || "-",
        saleBlock: item?.employee?.saleBlock?.name || "",
        saleArea: item?.employee?.saleArea?.name || "",
        createdAt: item?.createdAt,
        remainingRevenueAfterTax: item?.remainingRevenueAfterTax || 0, // Đã tính toán
        commissionPrice: item?.commissionPrice || 0,
        totalRemainingRevenueAfterTax: item?.totalRemainingRevenueAfterTax || 0, // Tất cả
        remainingCommissionPrice: item?.remainingCommissionPrice, // PDV còn lại (lũy kế, BE tính)
        monthYearBreakdown: item?.monthYearBreakdown || [], // Tách theo Tháng ĐC (import)
        // Tách số tiền đợt (import): PDV + thưởng nóng, null = đợt không có phần tách
        pdvPaidAmount: item?.pdvPaidAmount ?? null,
        hotBonusPaidAmount: item?.hotBonusPaidAmount ?? null,
        paymentNote: item?.paymentNote || "", // Ghi chú PDV + thưởng nóng (import)
        employeeObject: item?.employeeObject || {},
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching checkIn data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function usePaymentServiceFee(search, lockingId, period, periodPayment) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, search, lockingId, period, periodPayment],
    queryFn: () =>
      fetchPaymentServiceFee(
        currentPage,
        search,
        lockingId,
        period,
        periodPayment,
      ),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching checkIn data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    lockingManagementData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
